export const SUPPORTED_LANGUAGES = [
  'en',
  'fr',
  'es',
  'vi',
  'th',
  'id',
  'zh-hant',
  'pa',
] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_NATIVE_NAMES: Record<SupportedLanguage, string> = {
  en: 'English',
  fr: 'Français',
  es: 'Español',
  vi: 'Tiếng Việt',
  th: 'ไทย',
  id: 'Bahasa Indonesia',
  'zh-hant': '繁體中文',
  pa: 'ਪੰਜਾਬੀ',
};

const CHINESE_VARIANTS = ['zh', 'zh-hant', 'zh-tw', 'zh-hk', 'zh-mo'];

export function normalizeLanguage(code?: string | null): SupportedLanguage {
  if (!code) return 'en';

  const lower = code.toLowerCase();

  const exact = SUPPORTED_LANGUAGES.find((supported) => supported === lower);
  if (exact) return exact;

  if (CHINESE_VARIANTS.includes(lower)) return 'zh-hant';

  const base = lower.split('-')[0];
  return SUPPORTED_LANGUAGES.find((supported) => supported === base) ?? 'en';
}
